export type MenuItem = {
  id: string;
  title: string;
  description: string;
  icon: string;
  path: string;
  live: boolean;
  comingSoon: boolean;
  adminOnly?: boolean;
};

export const menuItemsGlobal: MenuItem[] = [
  {
    id: 'academy',
    title: 'Getting Started',
    description: 'New user? Head to the training videos page and watch the video tutorials to get you started.',
    icon: 'school',
    path: '/academy',
    live: true,
    comingSoon: false,
  },
  {
    id: 'visualization',
    title: 'Site Visualisation',
    description: 'Interactive floorplans showing device activity and heatmaps.',
    icon: 'map',
    path: '/visualization',
    live: true,
    comingSoon: false,
  },
  {
    id: 'floorplan-mapper',
    title: 'Augmented Maps',
    description: 'Bring floorplans to life with movement data overlaid onto google maps.',
    icon: 'satellite_alt',
    path: '/floorplan-mapper',
    live: true,
    comingSoon: false,
  },
  {
    id: 'visit-replay',
    title: 'Visit Replay',
    description: 'Audit technician visits and retrace the service route.',
    icon: 'route',
    path: '/visit-replay',
    live: true,
    comingSoon: false,
  },
  {
    id: 'ai-analysis',
    title: 'AI Analysis',
    description: 'Generate AI-powered reports and insights from your data.',
    icon: 'auto_awesome',
    path: '/ai-analysis',
    live: true,
    comingSoon: false,
  },
  {
    id: 'sensei-pathways',
    title: 'Sensei Pathways',
    description: 'Visualise rodent movement pathways across Sensei-monitored sites.',
    icon: 'directions_walk',
    path: '/sensei-pathways',
    live: false,
    comingSoon: true,
  },
  {
    id: 'site-reporting',
    title: 'Account Management Reporting',
    description: 'Compare site and sector performance and generate benchmarking reports.',
    icon: 'bar_chart',
    path: '/site-reporting',
    live: true,
    comingSoon: false,
    adminOnly: true,
  },
  {
    id: 'settings',
    title: 'System Settings',
    description: 'Manage users and device configurations.',
    icon: 'settings',
    path: '/admin',
    live: true,
    comingSoon: false,
    adminOnly: true,
  },
];

export const menuItemsUS: MenuItem[] = menuItemsGlobal.filter(
  item => item.path === '/academy' ||
          item.path === '/visualization' ||
          item.path === '/floorplan-mapper' ||
          item.path === '/admin' ||
          item.path === '/site-reporting'
);

export const menuItems: MenuItem[] = import.meta.env.VITE_MARKET === 'US'
  ? menuItemsUS
  : menuItemsGlobal;
